import { useState, useEffect } from 'react';
import { isMaster } from 'api/index';
import { useNavigate } from 'react-router-dom';
import { getArgFromUrl } from '../utils/index';

export default function Page() {
  const navigate = useNavigate();

  useEffect(() => {
    const id = getArgFromUrl('uid') || '';
    isMaster(Number(id)).then((res) => {
      if (res) {
        navigate('/mine');
      } else {
        navigate('/invite-list');
      }
    });
  }, []);

  return <div></div>;
}
